import ethereumPlugin from '@exodus/ethereum-plugin';
import ethereumHoleskyPlugin from '@exodus/ethereumholesky-plugin';
export const ethereum = ethereumPlugin;
export const ethereumholesky = ethereumHoleskyPlugin;
